
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import OtherPartyNprSurvey from "./OtherPartyNprSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";
import Tooltip from "@/components/survey/Tooltip.vue";

import OtherPartyPopupNpr from "./OtherPartyPopupNpr.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
      OtherPartyNprSurvey,
      PageBase,
      Tooltip,
      OtherPartyPopupNpr
    }
})
export default class OtherPartyNpr extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public types!: string[]

    @applicationState.State
    public steps!: stepInfoType[];   
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdateCommonStepResults!: (newCommonStepResults) => void


    @Watch('otherPartyData')
    otherPartyDataChange(newVal) 
    {   if(this.dataReady){            
            this.confirmed = false;          
            this.determineConfirmError();
            this.UpdateStepResultData({step:this.step, data: {otherPartyNprSurvey: this.getOtherPartyResults()}})
        }
    }


    currentStep=0;
    currentPage=0;
    showServeNoticeInfo = false;
    showPartyInfo = false;
    showTable = true;
    popInfo = false;
    popInfoUnderstand = '';    
    otherPartyData = [];
    anyRowToBeEdited = null;
    editId = null;

    dataReady = false;

    confirmed = false;
    confirmedError = false;
    tableIsEmpty = false;
 
    created() {
        if (this.step.result?.otherPartyNprSurvey) {
            this.otherPartyData = this.step.result.otherPartyNprSurvey.data;
        }
    }

    mounted(){
        
        this.dataReady = false;
        this.confirmed = false;

        this.tableIsEmpty = this.otherPartyData.length == 0 ;
                
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;  

        if(this.step.result?.otherPartyNprConfirmationSurvey?.data?.confirmation == 'Confirmed'){
            this.confirmed = true
        }
                 
        this.determineConfirmError();

        Vue.nextTick(()=>this.dataReady = true);
    }

    public determineConfirmError(){

        this.confirmedError = !this.tableIsEmpty && !this.confirmed && this.otherPartyData?.length>0;
        
        const progress = (!this.confirmed)||(this.otherPartyData && this.otherPartyData.length==0)? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        
        this.UpdateStepResultData({step:this.step, data:{otherPartyNprConfirmationSurvey: this.getConfirmationResults(this.confirmed?'Confirmed':'')}})
        
    }
    
    public openForm(anyRowToBeEdited?) {

        this.showTable = false;
        Vue.nextTick(()=>{
            const el = document.getElementById('other-party-common-survey')
            
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }    

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(opValue) {
        const currentIndexValue =
            this.otherPartyData && this.otherPartyData.length > 0 ? this.otherPartyData[this.otherPartyData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newParty = { ...opValue, id };

        this.otherPartyData = this.otherPartyData?[...this.otherPartyData, newParty]:[newParty];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.otherPartyData = this.otherPartyData.filter(data => {
        return data.id !== rowToBeDeleted;
        });
        this.tableIsEmpty = this.otherPartyData.length == 0 ;
    }

    public editRow(editedRow) {
        this.otherPartyData = this.otherPartyData.map(data => {
            return data.id == this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {             
        this.popInfo = true;              
    }

    public closePopInfo() {
        this.popInfo = false; 
        this.confirmed = true;
        Vue.prototype.$UpdateGotoNextStepPage();        
    }

    public isDisableNext() {
        return this.otherPartyData? (this.otherPartyData.length <= 0): true;
    }

    beforeDestroy() {
        
        if(this.otherPartyData && this.otherPartyData.length>0){
            this.$store.commit("Application/setRespondentName", this.otherPartyData[0].name);
            const respondentName = this.otherPartyData.map(otherParty=>otherParty.name)
            this.UpdateCommonStepResults({data:{'respondentsCommon':respondentName}})
        }  
        this.mergeRespondants()    

        this.determineConfirmError();
       
        this.UpdateStepResultData({step:this.step, data:{otherPartyNprSurvey: this.getOtherPartyResults()}})       
    }

    public getConfirmationResults( confirmation){
        const questionResults: {name: string; value: any; title: string; inputType: string}[] =[];
        questionResults.push({name:'otherPartyNprSurveyConfirmation', value:confirmation, title:'I understand each other party must be given notice of my application', inputType:''})
        return {data: {confirmation:confirmation}, questions:questionResults, pageName:'Other Party Confirmation', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public mergeRespondants(){
        const respondentName =[]
        if(this.$store.state.Application.steps[0].result && this.$store.state.Application.steps[0].result.respondentsPO){
            const respondentPO = this.$store.state.Application.steps[0].result.respondentsPO        
            respondentName.push(...respondentPO)
        }
        if(this.$store.state.Application.steps[0].result && this.$store.state.Application.steps[0].result.respondentsCommon){
            const respondentCommon = this.$store.state.Application.steps[0].result.respondentsCommon
            respondentName.push(...respondentCommon)
        }
        
        
        const fullNamesArray =[];
        for(const name of respondentName ){
            fullNamesArray.push(Vue.filter('getFullName')(name))
        }

        const uniqueArray = respondentName.filter(function(item, index) {
            const fullName = Vue.filter('getFullName')(item)
            return fullNamesArray.indexOf(fullName) == index;
        })
        
        this.UpdateCommonStepResults({data:{'respondents':uniqueArray}})
    }

    public getOtherPartyResults(){
        const questionResults: {name: string; value: any; title: string; inputType: string}[] =[];
        if(this.otherPartyData)
            for(const otherParty of this.otherPartyData)
            {
                questionResults.push({name:'otherPartyNprSurvey', value: this.getOtherPartyInfo(otherParty), title:'Other Party '+otherParty.id +' Information', inputType:''})
            }
        
        return {data: this.otherPartyData, questions:questionResults, pageName:'Other Party Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getOtherPartyInfo(otherParty){
        const resultString = [];
        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(otherParty.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(otherParty.dob))
        resultString.push(Vue.filter('styleTitle')("Lawyer: ")+(otherParty.lawyer?otherParty.lawyer:''));
        resultString.push(Vue.filter('styleTitle')("Address: ")+(otherParty.address?Vue.filter('getFullAddress')(otherParty.address):''))
        resultString.push(Vue.filter('styleTitle')("Contact: ")+Vue.filter('getFullContactInfo')(otherParty.contactInfo))
        return resultString
    }

}
